<template>
  <main v-if="ListProject.status != 'false'" class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    <div class="container" id="custom-cards">
      <div class="row row-cols-1 row-cols-lg-8 align-items-stretch g-4 py-5">
        <div class="col">
          <h3 class="pb-2 border-bottom text-dark-blue"><i class="fas fa-project-diagram margin-r" aria-hidden="true"></i>Edit Project </h3>
          <div class="card card-cover overflow-hidden text-white bg-white rounded-5 shadow-lg">
            <div class="d-flex flex-column  p-4 pb-3 text-blue text-shadow-1">
              <div style="display:inline !important">
                <h6 class="text-start card-title fw-bold"> Project Info </h6>
                <div class="container mt-4">
                  <form ref="ProjectForm" @submit.prevent="PostEditProject()">
                    <div class="col-md-12" align="left">
                      <label for="validationDefault01" class="form-label">Name</label>
                      <input type="text" v-model="ProjectPost.name" class="form-control" id="validationDefault01" required placeholder="Name of Project">
                    </div>
                    <div class="d-flex justify-content-end mt-3 m-1">
                      <a class=" btn btn-danger"  style="margin-right: 5px;" @click="$router.go(-1)"> Go Back</a>
                      <button :disabled="Form.submit"  class="button-1 btn btn-primary" type="submit">Save Project</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import Api from '@/services/Request'; 

  export default
  {
    name: 'ContentEditProject',
    data: () => (
    {
      ProjectPost: 
      {
        id:"",
        name: "",
        status:"",
        message:""
      },
      ListProject: 
      {
        id:"",
        status:""
      },
      Form: 
      {
        submit: false
      }
    }),
    methods: 
    {
      PostEditProject() 
      {
        Api.post("/project/edit",this.ProjectPost).then((result) => 
        {
          this.Form.submit = true

          if(result.data.status == "true")
          {
            this.ProjectPost.status = result.data.status
            this.ProjectPost.message = result.data.msg;

            this.$moshaToast( ''+this.$filters.OnlyLetters(this.ProjectPost.message)+'', { type: 'default', position:'bottom-right', transition:'zoom' })
        
            setTimeout( () => 
            {
              this.ProjectPost.message = ""
              this.ProjectPost.status = ""
              this.Form.submit = false
            }, 5000);
          }
        })    
      },
      GetProject() 
      {
        Api.get('/project/list/' + this.$route.params.id).then((result) => 
        {
          this.ListProject.status = result.data.status

          if(this.ListProject.status == "true")
          {
            this.ProjectPost.name =  result.data.project[0].name
            this. ProjectPost.id =  result.data.project[0].id
          }
        })
      }
    },
    mounted()
    {
      this.GetProject()
    }
  }
</script>

<style></style>
